import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';
import moment from 'moment';

@Pipe({
    name: 'attributeValue',
    standalone: true
})
export class AttributeValuePipe implements PipeTransform {
  transform(
    value: string,
    type: 'date' | 'string' | 'boolean' | 'number'
  ): string {
    if (type === 'date') {
      return moment(value).format(ConfigService.dates.dateFormat);
    } else {
      return value;
    }
  }
}
